<template>
  <v-card tile style="background-color: #F5F5F5;">
    <v-toolbar flat dark color="#01579B">
      <v-btn icon dark @click="closeDocModal()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Documents</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-divider></v-divider>
      <v-list three-line subheader>
        <v-subheader>Original Document</v-subheader>
      </v-list>

      <v-row>
        <v-col cols="12" md="6">
          <embed
            :src="url2 + singleDoc.document_name"
            width="100%"
            height="100%"
          />
        </v-col>

        <v-col cols="12" md="6" class="p-4">
          <h1 class="display-1">
            Edit document (Preview)
          </h1>
          <v-divider></v-divider>

          <template
            v-if="!singleDoc.json_data || singleDoc.json_data == 'false'"
          ></template>
          <template v-else>
            <form id="myFormId">
              <div class="form-group">
                <div
                  class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                >
                  <div
                    class="sm:col-span-3"
                    v-for="single in JSON.parse(singleDoc.json_data)"
                    :key="single.id"
                  >
                    <!-- v-if="single.FieldName" -->
                    <div class="form-group">
                      <label class="block text-sm font-medium text-gray-700">
                        {{ single.FieldName }}
                      </label>
                      <template
                        v-if="single.FieldType == 'Text'"
                        id="contenedor"
                      >
                        <input
                          class="form-control"
                          type="text"
                          :name="single.FieldName"
                          value=""
                        />
                      </template>

                      <template v-else-if="single.FieldType == 'Button'">
                        <input
                          class="ml-2"
                          type="checkbox"
                          :name="single.FieldName"
                          value=""
                          :id="single.FieldName"
                        />
                      </template>

                      <template v-else-if="single.FieldType == 'Choice'">
                        <select
                          multiple
                          class="form-control"
                          id="exampleFormControlSelect2"
                        >
                          <option
                            v-for="(value, index) in single.FieldStateOption"
                            :key="index"
                          >
                            {{ value }}
                          </option>
                        </select>
                      </template>
                    </div>

                    <!-- <div v-else>
                            <div class="form-group">
                                <label>
                                {{ single.name }}
                                </label>

                                <div v-if="single.box">
                                <input
                                    class="ml-2"
                                    type="checkbox"
                                    :name="single.name"
                                    :value="
                                    single.value === 'Yes'
                                        ? true
                                        : false
                                    "
                                />
                                </div>
                                <input
                                class="form-control"
                                type="text"
                                :name="single.name"
                                :value="single.value"
                                />
                            </div>
                            </div> -->
                  </div>

                  <v-btn
                    rounded
                    type="submit"
                    @click.prevent="createSubmission(singleDoc)"
                    small
                    color="#0D47A1"
                    dark
                  >
                    Save Changes
                  </v-btn>
                </div>
              </div>
            </form>
          </template>
        </v-col>
      </v-row>
    </v-card-text>

    <div style="flex: 1 1 auto;"></div>
  </v-card>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import Swal from "sweetalert2";

export default {
  props: ["singleDoc"],
  data() {
    return {
      url: process.env.VUE_APP_API_URL_FILES,
      url2: process.env.VUE_APP_API_URL_S3
    };
  },

  methods: {
    createSubmission(singleDoc) {
      var queryString = $("#myFormId input:text").serializeArray(); // store json object
      // console.log(queryString);
      $("#myFormId input:checkbox").each(function(i, e) {
        queryString.push({
          name: e.name,
          value: e.checked ? "Yes" : "Off",
          box: true
        });
      });

      window.axios
        .post("/api/updateSubmission/" + singleDoc.id, {
          queryString: queryString
        })
        .then(() => {
          this.dialog2 = false;
          this.singleDoc = "";

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Form data succesfully sent, Waiting for aprove",
            showConfirmButton: false,
            timer: 1500
          });
          this.$emit("updated");
          this.$emit("clicked");
        });
    },

    closeDocModal() {
      this.$emit("clicked");
    }
  }
};
</script>
